import moment from 'moment';
import { reducerAccumulator } from '@widergy/web-utils/lib/array';

import { appConfig } from 'config/customization';
import { UTILITIES } from 'constants/utilitiesMappers';

const EdelapUnpaidBillsMapper = (debts = [], account) =>
  debts.map(bill => ({
    ...bill,
    client_number: account.client_number,
    issued_on: moment(bill.issued_on).format('L'),
    first_expiration_on: moment(bill.first_expiration_on).format('L'),
    payable: bill.payable
  }));

const EdesUnpaidBillsMapper = (debts = []) => debts.map(bill => ({ ...bill, payable: true }));

const UNPAID_BILLS_MAPPERS = {
  [UTILITIES.eden]: EdesUnpaidBillsMapper,
  [UTILITIES.edelap]: EdelapUnpaidBillsMapper,
  [UTILITIES.edes]: EdesUnpaidBillsMapper,
  [UTILITIES.utilityco]: EdelapUnpaidBillsMapper
};

export const AccountUnpaidMapper = (debts, account) => ({
  client_number: account.client_number,
  id: account.id,
  address: account.address,
  balance: UNPAID_BILLS_MAPPERS[appConfig.mappers](debts, account)
    .filter(element => element.payable)
    .map(item => item.balance)
    .reduce(reducerAccumulator, 0),
  debts: UNPAID_BILLS_MAPPERS[appConfig.mappers](debts, account)
});
